import React from 'react';

interface TableBodyProps {
  className?: string;
  children?: React.ReactNode;
}

// eslint-disable-next-line react/display-name -- auto-generated TECH-258
export const TableBody = React.forwardRef<HTMLTableSectionElement, TableBodyProps>(({ children, className }, ref) => (
  <tbody className={className} ref={ref}>
    {children}
  </tbody>
));

export default TableBody;
